// /src/locations/locations_gen72.js
export default [
  "Starter",
  "Route 1 (Gras)",
  "Trainer-Schule",
  "Hauholi City (Geschenk/Event)",
  "Route 2 (Gras)",
  "Friedenshöhle (Prüfung)",
  "Route 3 (Gras)",
  "Mele-Mele-Wiese",
  "Kala'e-Bucht",
  "Tenkarat-Hügel (Gras/Höhle)",
  "Route 4 (Gras)",
  "Paniola Town (Geschenk)",
  "Paniola Ranch",
  "Route 5 (Gras)",
  "Tropen-Hügel (Ultrasonne exklusiv)",
  "Brooklet Hill (Prüfung – Wasser)",
  "Digda-Tunnel (Höhle)",
  "Route 6 (Gras)",
  "Royal Avenue (Geschenk)",
  "Wela-Vulkanpark (Prüfung – Feuer)",
  "Route 7 (Wasser/Angeln)",
  "Route 8 (Gras)",
  "Schattendschungel (Prüfung – Pflanze)",
  "Konikoni City (Geschenk/Event)",
  "Route 9 (Gras)",
  "Memoria-Hügel",
  "Route 10 (Gras)",
  "Mount Hokulani (Prüfung – Elektro)",
  "Ula-Ula Strand (Angeln)",
  "Route 11 (Gras)",
  "Route 12 (Gras/Wasser)",
  "Seelengenossenschaft",
  "Route 13 (Gras)",
  "Route 14 (Angeln)",
  "Route 15 (Gras/Wasser)",
  "Haina-Wüste",
  "Ruine des Gedenkens",
  "Route 16 (Gras)",
  "Ula-Ula Blumenmeer",
  "Malie Garten",
  "Route 17 (Gras)",
  "Route 18 (Gras)",
  "Malie-Garten",
  "Hokulani-Berg",
  "Po'u (Prüfung – Unlicht)",
  "Aether-Paradies (Event)",
  "Poni-Küste",
  "Poni-Wiesen (Gras)",
  "Poni-Küstenpfad",
  "Große Schlucht von Poni (Prüfung)",
  "Antike Stätte von Poni",
  "Poni-Meerespfad (Surfen/Angeln)",
  "Baum des Lebens (Legendär)",
  "Ultrametropolis (Story)",
  "Siegesstraße (Höhle)",
  "Pokémon-Liga",
  "Ultra-Wurmloch",
  "Ultra-Megalopolis",
  "Heiligtum der Wächter",
  "Kampfbaum",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];
